import { inject } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

import { CorrelationService } from '../services/logger/correlation.service';

export const loggerInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const correlationService = inject(CorrelationService);

  correlationService.begin();

  const httpRequest = req.clone({
    headers: req.headers.set('X-Correlation-Id', correlationService.current.id),
  });
  return next(httpRequest).pipe(finalize(() => correlationService.end()));
};
